<template>
  <div class="warp">
 
    <div class="title">CAC2025 Visa Invitation Application Instructions</div>
    <div class="tipTitle">Invitation Process Time:30th.Nov. 2024---1st Mar.2025</div>
   
    <!-- <div class="contentText">From Dec 1, 2023, to Nov 30, 2024, China is implementing a visa exemption for ordinary passport holders from France, Germany, Italy, the Netherlands, Spain, and Malaysia for up to 15-day visits, including business, tourism, family visits, or transiting.</div> -->

    <div class="item">
      <div class="smallTitle">Step 1 Prepare Application Profile</div>
      <div class="smallTitle">Exhibitors</div>
      <div class="text">1. Visa Invitation Letter （refer to Attachment 1）</div>
      <div class="text">2. Invitation Application Form（refer to Attachment 2）</div>
      <div class="text">3. Scanned Passport Identity Page valid at least 6 months after your departing day（after September 19, 2025）</div>
      <div class="text">4. Company Certificate(refer to Attachment 3)</div>
    </div>

    <div class="item">
      <div class="smallTitle">Step 2 Application Profile Check</div>
      <div class="text">Submit Application Profile to yeximeng@ccpitchem.org.cn</div>  
      <div class="text">Submitted profile will be checked and supplementary profile may be requested.</div>
    </div>
   
    <div class="item">
      <div class="smallTitle">Step 3 Visa Invitation Issuance</div>
      <div class="text">3.1 Visa invitation will be issued at least 7 working days after requested and supplementary profiles are complete.</div>
      <div class="text">3.2 The scanned or faxed copy of the invitation will be sent to your contact above.</div>
      <div class="text">3.3Should you need the original invitation, we will order the courier service at applicant's charge.</div>
    </div>

    <div class="item">
      <div class="smallTitle">Contact</div>
      <div class="text">CCPIT Sub-council of Chemical Industry</div>
      <div class="text">Ms. Simone Ye Tel: 0086-10-64222845</div>
      <div class="text">Email: yeximeng@ccpitchem.org.cn</div>
    </div>
    <div class="item">
      <div class="text">To further facilitate the travel of people between China and foreign countries, China has decided to expand the scope of visa-free countries. From November 30, 2024, to December 31, 2025, a visa-free policy on a trial basis will be implemented for following countries for business, tourism, family visits, exchange visits, and transit stays not exceeding 30 days. Those who do not meet the visa-free criteria will still need to obtain a visa to China before entering.</div>
      <div class="smallTitle">The latest list of countries benefiting from China's visa free policy:</div>
      <table>
        <tbody>
          <tr>
            <td class="tabTitle">Countries for Visa-free mutual exemption：</td>
            <td class="text">Albania, Antigua and Barbuda, Armenia, Bahamas,
Barbados, Belarus, Bosnia and Herzegovina,
Dominic, Ecuador, Fiji, Georgia, Grenada, Kazakhstan,
Maldives, Mauritius, Qatar, SAN Marino,
Serbia, Seychelles, Singapore, Solomon Islands, Suriname, Thailand, The United Arab Emirates, Tonga</td>
          </tr>
          <tr>
            <td class="tabTitle">Countries for Visa-free stay not exceeding 30 days:</td>
            <td class="text">Andorra, Australia, Austria, Belgium, Brunei, Bulgaria, Croatia, New Zealand, Cyprus, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Iceland, Ireland, Italy, Japan, Korea, Latvia, Liechtenstein, Luxembourg, Malaysia, Malta, Monaco, Montenegro, Netherlands, Norse, North Macedonia, Poland, Portugal, Romania, Slovakia, Slovenia, Spain, Switzerland</td>
          </tr>
        </tbody>
      </table>
      <div class="text">Please refer to your local embassy of China or visa office for specific country visa policies. 
The above information for reference only.</div>
    </div>
<!-- 
    <div class="textInter">特别提示: 从今年12月1日起到明年11月30日，法国、德国、意大利、荷兰、西班牙和马来西亚的公民来华进行短期入境或过境，可享受免签待遇，停留时间不超过15天。</div> -->
    <!-- <div class="time">2023年11月</div> -->
    <div style="margin-top:10px;padding-bottom:90px">
      <el-button type="primary"  ><a :href="file1" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" download="">Attachment 1- Visa Invitation Letter sample.docx</a></el-button>
      <el-button type="primary"  ><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" download="">Attachment 2- Invitation Application form.xls</a></el-button>
      <el-button type="primary"  ><a :href="file3" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" download="">Attachment 3-certificate sample.doc</a></el-button>
    </div>

  </div>
</template>
<script>


export default {
  data(){
      return{
        file1:'./Attachment 1- Visa Invitation Letter sample.docx',
        file2:'./Attachment 2- Invitation Application form.xls',
        file3:'./Attachment 3- Certificate sample.doc'
      }
  },
  components: {},
  mounted() {
   
  },
  methods: {
  


  }
}
</script>
<style lang="less">

.warp{
  max-width: 80%;
  padding-left: 5% !important;
}
.title{
  font-size: 28px;
  text-align: center;
  padding-top:30px;
  padding-bottom: 10px;
  font-weight: bold;
}
.tipTitle{
  font-size: 20px;
  text-align: center;
  padding-bottom:30px;
  font-weight: bold;
}
.contentText{
  font-size: 20px;
  text-align: center;
  padding: 10px 0 20px;
  font-weight: bold;
}
.item{
  padding-bottom: 14px;
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse; /* 移除单元格之间的间隔 */
  }
  td {
    padding: 10px 6px;
  }
  .tabTitle{
    font-weight: bold;
    width: 11%;
    text-align: center;
  }
}
.item .smallTitle{
  font-weight: bold;
  padding:6px 0;
  font-size: 18px;
}
.item .text{
  font-size: 16px;
  line-height: 28px;
}
.textInter{
  font-size: 16px;
  line-height: 28px;
}
.time{
  font-size: 16px;
  text-align: right;
  padding-top: 10px;
}
.el-button--primary{
  margin: 5px 0;
}
</style>

